import { createAsyncThunk } from '@reduxjs/toolkit';

import { MasooliatMadaniApiPaths } from 'Feature/Asansour/Common/Constant/MasooliatMadaniApiPaths';
import { MasooliatMadaniHttpGetService } from 'Feature/Asansour/Common/Services/MasooliatMadaniHttpService';

export const printElhaghiyehMasooliatMadani = createAsyncThunk(
  'MasooliatMadani/printElhaghiyehMasooliatMadani',
  async (query: any) => {
    return await MasooliatMadaniHttpGetService({
      url: `${MasooliatMadaniApiPaths.BimehNamehHayeMadani.PrintElhaghiyehMadani}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);

export const getElhaghiyehHayeSadereh = createAsyncThunk('MasooliatMadani/getElhaghiyehHayeSadereh', async () => {
  return await MasooliatMadaniHttpGetService({
    url: `${MasooliatMadaniApiPaths.BimehNamehHayeMadani.GetElhaghiyehHayeSadereh}`,
  });
});
